import { render, staticRenderFns } from "./PageOrdinaryPackage.vue?vue&type=template&id=ff62a4e0&scoped=true"
import script from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
export * from "./PageOrdinaryPackage.vue?vue&type=script&lang=js"
import style0 from "./PageOrdinaryPackage.vue?vue&type=style&index=0&id=ff62a4e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff62a4e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff62a4e0')) {
      api.createRecord('ff62a4e0', component.options)
    } else {
      api.reload('ff62a4e0', component.options)
    }
    module.hot.accept("./PageOrdinaryPackage.vue?vue&type=template&id=ff62a4e0&scoped=true", function () {
      api.rerender('ff62a4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/csg/sku/components/PageOrdinaryPackage.vue"
export default component.exports